import React from 'react';
import { Link } from 'react-router-dom';
// import blogs from '../../api/blogs';

// import { Link } from 'react-router-dom'
import projMan from '../../images/projSub.jpg'
import blog4 from '../../images/blog-details/comments-author/img-2.jpg'
import blog5 from '../../images/blog-details/comments-author/img-3.jpg'
import blog6 from '../../images/blog-details/author.jpg'
import blogs from '../../api/blogs';
import { useParams } from 'react-router-dom';
import Secretary from '../../images/studentReq.jpg';


// const ClickHandler = () => {
//     window.scrollTo(10, 0);
// }

const Counsellor = (props) => {

    const { slug } = useParams()

    const BlogDetails = blogs.find(item => item.slug === slug)

    const submitHandler = (e) => {
        e.preventDefault()
    }

  return (
    <section className="blog-single-section section-padding">
            <div className="container">
                <div className="row">
                    <div className={`col col-lg-9 col-12 ${props.blRight}`}>
                        <div className="blog-content">
                            

                            <div className="tag-share">
                            <div className="post format-standard-image">
                                <div className="entry-media">
                                    <img src={Secretary} alt="" />
                                </div>
                                <ul className="entry-meta">
                                    <li><Link to="">FFSD GROUP</Link></li>
                                    <li><Link to="">30th October, 2025.</Link></li>
                                    <li><Link to="">Application Deadline: 10th November 2025.</Link></li>
                                </ul>
                                <h2>Job Title: Students Recruitment Counsellor <br /> Location: Wuse, Abuja. FCT. <br/> Employment Type: Full-Time.</h2>
                                <h3>About Us</h3>
                                <p>FFSD Education is a goal-oriented and dynamic international education recruitment agency with a track record in providing high-quality, person-centred support and we are looking for a student recruitment counsellor to join our team.</p>
                                
                                <h3>What you'll Do</h3>
                                <p>
                                    - Strategically generate, develop and convert leads from the top of the marketing funnel to meet and exceed annual targets. <br />
                                    - Manage inbound leads from multiple sources, including direct event participation and social media campaigns designed to attract interest in FFSD. <br />
                                    - Proactively engage with prospective customers across mail, phone, and social platforms to build interest in FFSD offerings. <br />
                                    - Counsel prospective applicants on the right study options, including courses and institutions. <br />
                                    - Assist applicants through admissions, visa, and pre-departure processes. <br />
                                    - Keep abreast of competition, competitive issues, and FFSD products and offerings. <br />
                                    - Act with a high level of professionalism and accountability. <br />
                                    - Support Business Development with promotional events. <br />
                                    - Process and submit applications to partner institutions, obtain offers, ensure students provide adequate documents, and enrol in a timely manner. <br />
                                    - Participate in and actively organize education fairs. <br />
                                    </p>

                                <h3>What you'll need to Succeed</h3>
                                <p>
                                    - Bachelor’s degree or equivalent in any field. <br />
                                    - 2-4 years of relevant working experience, of which at least 2 years in sales, client development, or commercial roles, preferably from a creative agency (sales, business development, account manager, etc.). <br />
                                    - A proven top performer in previous sales and/or commercial jobs with a track record in achieving commercial targets. <br />
                                    - Master of social selling and a keen networker with a genuine interest in the field of marketing and/or creative industries. <br />
                                    - Self-confident English communicator, comfortable speaking with and pitching to executive management on the phone, via video conference, or in writing. <br />
                                    - Proactiveness with applicants and partner institutions. <br />
                                    - Must have a knack for building and managing relationships with clients. <br />
                                    - Proven ability to work independently and with minimal supervision. <br />
                                    - Previous work experience as a student counsellor, a consultant or sales representative will be an added advantage. <br />
                                </p>

                                <h3>Personal Attributes</h3>
                                <p>
                                    - Love to talk to people. <br />
                                    - Ambitious and willing to work in a fast-moving company. <br />
                                    - Strong communication skills. <br />
                                    - Like to get things done and have a high level of grit and resilience. <br />
                                    - Competitive, systematic, self-driven, and enjoy setting and exceeding your KPIs. <br />
                                    - Must reside in Wuse or its environs. <br />
                                </p>

                                {/* <h3>What We Offer</h3>
                                <p>
                                    - Competitive salary.  
                                    - Opportunity to work on a high-profile project with an established company.  
                                    - Professional growth and development opportunities.
                                </p> */}

                                <h3>How to Apply</h3>
                                <p>
                                If you are passionate about helping students achieve their educational goals, we would love to hear from you. Please send your CV, degree certificate and a cover letter to <a href="mailto:careers@ffsdgroup.com"> careers@ffsdgroup.com </a> with the job title “Students Recruitment Counsellor” as the subject. 
                                </p>

                                {/* <h3>Experience</h3>
                                <p>
                                Product Marketing: 2 years (Required) 
                                </p> */}

                                <h3>Pay</h3>
                                <p>
                                180,000 - 200,000 per month
                                </p>
                            </div>
                            {/* <h4>Location: Asaba, Delta State, Nigeria. <br/> Contract Duration: 6 Months to 1 Year.</h4> */}
                            </div>

                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
  )
}

export default Counsellor;